// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Input_Input_s67N0 {\n  width: 100%;\n  outline: none;\n  font-size: 16px;\n  -webkit-transition: border-bottom-color 0.5s ease;\n  transition: border-bottom-color 0.5s ease;\n  padding-bottom: 4px;\n}\n.Input_Input_s67N0[type=\"text\"] {\n  border-bottom: 2px solid black;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n.Input_Input_s67N0[type=\"text\"].Input_Error_34t1l {\n  border-color: red;\n  color: red;\n}\n.Input_Input_s67N0:focus {\n  border-bottom-color: #76b900;\n}\n.Input_Container_2Oyhx {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.Input_ErrorMessage_CPrf- {\n  color: red;\n}\n", ""]);
// Exports
exports.locals = {
	"Input": "Input_Input_s67N0",
	"Error": "Input_Error_34t1l",
	"Container": "Input_Container_2Oyhx",
	"ErrorMessage": "Input_ErrorMessage_CPrf-"
};
module.exports = exports;
